<main class="middle-content">
    <div class="content-section">
        <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item active">
                <a routerLink="/subadmin-mgt">Patient Management </a>
            </li>
            <li class="breadcrumb-item">Edit</li>
        </ol>
        <div class="order-view mt30 max-WT-700 mrgn-0-auto">
            <form [formGroup]="addSubAdminForm">
                <div class="main-block-innner mb40 mt40">
                    <div class="add-store-block input-style">

                        <!-- **********************Subadmin profile image ****************  -->

                        <div class="text-center mt-4 mb-5">
                            <div class="flex-block align-center">
                                <div class="profile_block" style="position: relative">
                                    <img [src]="imageUrl || 'assets/img/profile-img.jpg'" class="imagePicture"
                                        alt="Patient image" (error)="onImageError($event)" />
                                    <br>
                                    <span class="camera">
                                        <i class="fa fa-camera" style="display:flex; ">
                                            <input type="file"
                                                [attr.disabled]="programStatus == 'notAssign' ? true : null"
                                                class="cameraInput" accept="image/jpg,image/jpeg,image/png" id="file"
                                                formControlName='file' (change)="ValidateFileUpload($event)">
                                        </i> </span>

                                </div>
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> First Name :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="text" [attr.disabled]="programStatus == 'notAssign' ? true : null"
                                    class="form-control" placeholder="First name"
                                    [formControl]="addSubAdminForm.controls['firstName']" maxlength="256"
                                    (keypress)="inputkeyPress($event)" minlength="2">
                                @if((addSubAdminForm.controls['firstName'].dirty ||
                                addSubAdminForm.controls['firstName'].touched) &&
                                addSubAdminForm.controls['firstName'].invalid){
                                <div class="error-block">
                                    @if(addSubAdminForm.controls['firstName'].hasError('required')){
                                    <span style='color:red'
                                        [ngClass]="{error:addSubAdminForm.controls['firstName'].hasError('required')}">
                                        *Please enter user first name.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['firstName'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['firstName'].hasError('pattern')}">
                                        *First name should be characters only.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['firstName'].hasError('maxlength') &&
                                    !addSubAdminForm.controls['firstName'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['firstName'].hasError('maxlength') && addSubAdminForm.controls['firstName'].dirty}">
                                        *First name should be maximum 256 characters.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['firstName'].hasError('minlength') &&
                                    !addSubAdminForm.controls['firstName'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['firstName'].hasError('minlength') && addSubAdminForm.controls['firstName'].dirty}">
                                        *First name should be atleast 2 characters.
                                    </span>
                                    }
                                </div>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Last Name :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="text" [attr.disabled]="programStatus == 'notAssign' ? true : null"
                                    class="form-control" placeholder="Last name"
                                    [formControl]="addSubAdminForm.controls['lastName']" maxlength="256"
                                    (keypress)="inputkeyPress($event)" minlength="2">
                            </div>
                        </div>


                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Email :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="email" [attr.disabled]="true" class="form-control" placeholder="Email"
                                    (keypress)="passwordKeyPress($event)"
                                    [formControl]="addSubAdminForm.controls['email']" maxlength="50">
                                @if(addSubAdminForm.controls['email'].dirty &&
                                addSubAdminForm.controls['email'].invalid){
                                <div class="error-block">
                                    @if(addSubAdminForm.controls['email'].hasError('required')){
                                    <span style='color:red'
                                        [ngClass]="{error:addSubAdminForm.controls['email'].hasError('required')}">
                                        *Please enter an email.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['email'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['email'].hasError('pattern')}">
                                        *Please enter valid email.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['email'].hasError('maxlength') && !
                                    addSubAdminForm.controls['email'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['email'].hasError('maxlength') && addSubAdminForm.controls['email'].dirty}">
                                        *Please enter valid email.
                                    </span>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6>Phone Number : </h6>
                            </label>
                            <div class="col-md-3">
                                <select name="patient" [attr.disabled]="true" style="padding: 0 40px"
                                    formControlName="phoneCode" class="custom-select form-control"
                                    id="inputGroupSelect01" aria-labelledby="dropdownMenuButton">
                                    @for (data of countryArr; track data; let i = $index) {
                                    <option [value]="data.phone_code">
                                        {{data.phone_code}} &nbsp; {{data.name}}</option>
                                    }
                                </select>
                            </div>
                            <div class="col-md-5">
                                <input type="tel" [attr.disabled]="true" class="form-control" placeholder="Phone Number"
                                    (keypress)="inputKeyPress($event)"
                                    [formControl]="addSubAdminForm.controls['phoneNumber']" maxlength="20">
                                @if(addSubAdminForm.controls['phoneNumber'].dirty &&
                                addSubAdminForm.controls['phoneNumber'].invalid){
                                <div class="error-block text-nowrap">
                                    @if(addSubAdminForm.controls['phoneNumber'].hasError('required')){
                                    <span style='color:red'
                                        [ngClass]="{error:addSubAdminForm.controls['phoneNumber'].hasError('required')}">
                                        *Please enter a phone number.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['phoneNumber'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['phoneNumber'].hasError('pattern')}">
                                        *Please enter valid Phone number.
                                    </span>
                                    }
                                </div>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6>Assign Therapist: </h6>
                            </label>
                            <div class="col-md-8">
                                <select name="patient" [attr.disabled]="programStatus == 'notAssign' ? true : null"
                                    style="padding: 0 40px" formControlName="therapyName"
                                    (change)="getSlotofTherapistApi(addSubAdminForm.controls['therapyName'].value)"
                                    class="custom-select form-control" id="inputGroupSelect01"
                                    aria-labelledby="dropdownMenuButton">
                                    <option value="" disabled>Assign Therapist</option>
                                    @for (therapy of therapistList; track therapy; let i = $index) {
                                    <option value="{{therapy._id}}/{{therapy.firstName}}/{{therapy.lastName}}">
                                        {{therapy.firstName}}</option>
                                    }
                                </select>
                            </div>
                        </div>

                        @if(programStatus == 'notAssign'){
                        <div class="form-group row mb-4 align-items-center">
                            <label class="col-md-4">
                                <h6>Select Program: </h6>
                            </label>
                            <div class="col-md-8">
                                <select name="patient" style="padding: 0 40px" formControlName="programName"
                                    class="custom-select form-control" id="inputGroupSelect01"
                                    aria-labelledby="dropdownMenuButton">
                                    <option value="" disabled>Select Program</option>
                                    @for (program of programList; track program; let i = $index) {
                                    <option value="{{program?._id}}">
                                        {{program?.title}}</option>
                                    }
                                </select>
                            </div>
                        </div>
                        }
                        <div class="text-center mt40">
                            <button class="btn btn-theme" (click)="editPatientApi()">Save</button>
                            <button class="btn btn-danger" style="margin-left: 20px;min-width: 100px;"
                                routerLink="/patient-mgt">Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</main>

<!-- *************************Therapist Calendar start here ******************************** -->
<div class="modal fade global-modal reset-modal" id="therapistCalender">
    <div class="modal-dialog max-WT-1000">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="row d-flex justify-content-end">
                            <div class="text-right align-items-center d-flex ">
                                <label class="bookedSessions"></label>
                                <label class="ms-1 text-nowrap">Booked slot</label>
                                <label class="Sessions ms-3"></label>
                                <label class="ms-1 text-nowrap">Available slot</label>
                                <label class="UnavailableSessions ms-3"></label>
                                <label class="ms-1 text-nowrap">Unavailable slot</label>
                                <label class="btn-close" data-dismiss="modal" aria-label="Close">
                                    <i class="fa fa-times cross" data-dismiss="modal" aria-hidden="true"></i>
                                </label>
                            </div>
                        </div>

                        <div class="m-3">
                            <h5 class="text-center">Mr. {{therapistFullName}}</h5>
                        </div>
                        <div class="table-responsive">
                            <div class="d-flex max-WT-550">
                                @for (day of weekDaysofTherapist; track day; let i = $index) {
                                <label class="ms-3 text-nowrap font14">
                                    <span [ngClass]="{active : (selectedDay == day?._id)}"
                                        (click)="dateChange(day?._id)">
                                        {{day?.scheduleDate | date : 'EEE,d MMM' :'UTC'}}
                                    </span>
                                    @for (time of day?.schedule; track time; let i = $index) {
                                    <p (click)="assignTherapistModalAlert(time?._id, time?.status)"
                                        [ngStyle]="{'background-color' : time?.status === 'AVAILABLE' ? '#28a745' : time?.status === 'INACTIVE' ? 'orange': 'red' ,'color' : 'white'}"
                                        class="border my-3 bg-gray font14 text-center"
                                        [ngClass]="{active : selectedDay == day?._id}">
                                        {{time?.offsetDate | slice : 11:16 }}
                                    </p>
                                    }
                                </label>
                                }
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>


<!-- *************************Therapist Calendar start here ******************************** -->

<!-- ----------------  Active and block patient modal ----------------------- -->

<div class="modal fade global-modal reset-modal" id="assignTherapist">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Assign Therapist?</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure you want to assign therapist to this slot?</p>
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme" (click)="slotChange()">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>